import { CellType } from '@grapecity/wijmo.grid';
import { CollectionView } from '@grapecity/wijmo';
import * as React from 'react';
import * as wijmo from '@grapecity/wijmo';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjGrid from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { isBeforeThisMonth } from 'utils/dateUtils';

import { Col, Row, Container } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';

import { toInt, toFloat, calcRate } from 'utils/numberUtils';
import './Analysis.css';

// 分析（契約件数）（工事／管・小）
function AnalysisKeiBigSmall(props) {
  const gridRef = useRef(null);

  // 見積依頼リスト
  const quoteList = props.quoteList;

  // 契約情報リスト
  const [keiyakuLit, setKeiyakuLit] = useState(new CollectionView([]));
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;

  // 前期のリピート件数
  const [bigRepeatCount, setBigRepeatCount] = useState(0);
  // 前期の新規件数
  const [bigNewCount, setBigNewCount] = useState(0);
  // 今期のリピート件数
  const [smallRepeatCount, setSmallRepeatCount] = useState(0);
  // 今期の新規件数
  const [smallNewCount, setSmallNewCount] = useState(0);

  useEffect(() => {
    // 契約率を算出
    setKeiyakuLit(
      new CollectionView(
        quoteList.items.map((item) => ({
          ...item,
          SMALL_REPEAT_KEI_RATE: calcRate(item.KEI_SMALL_REPEAT, item.SMALL_REPEAT, 4),
          SMALL_NEW_KEI_RATE: calcRate(item.KEI_SMALL_NEW, item.SMALL_NEW, 4),
          SMALL_TOTAL_KEI_RATE: calcRate(item.KEI_SMALL_TOTAL, item.SMALL_TOTAL, 4),
          BIG_REPEAT_KEI_RATE: calcRate(item.KEI_BIG_REPEAT, item.BIG_REPEAT, 4),
          BIG_NEW_KEI_RATE: calcRate(item.KEI_BIG_NEW, item.BIG_NEW, 4),
          BIG_TOTAL_KEI_RATE: calcRate(item.KEI_BIG_TOTAL, item.BIG_TOTAL, 4),
        }))
      )
    );
  }, [quoteList]);

  useEffect(() => {
    if (gridRef.current) {
      updateFooter(gridRef.current.control);
    }

    // 工事のリピート・新規件数を計算
    setBigRepeatCount(
      keiyakuLit.sourceCollection.reduce((sum, item) => sum + toInt(item.KEI_BIG_REPEAT, 0), 0)
    );
    setBigNewCount(
      keiyakuLit.sourceCollection.reduce((sum, item) => sum + toInt(item.KEI_BIG_NEW, 0), 0)
    );

    // 管・小のリピート・新規件数を計算
    setSmallRepeatCount(
      keiyakuLit.sourceCollection.reduce((sum, item) => sum + toInt(item.KEI_SMALL_REPEAT), 0)
    );
    setSmallNewCount(
      keiyakuLit.sourceCollection.reduce((sum, item) => sum + toInt(item.KEI_SMALL_NEW, 0), 0)
    );
  }, [keiyakuLit]);

  //  グリッドの初期化
  function onInitialized(grid) {
    // ヘッダーを2段にする
    var extraRow = new wjGrid.Row();
    extraRow.allowMerging = true;

    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);

    for (let colIndex = 1; colIndex <= 4; colIndex++) {
      panel.setCellData(0, colIndex, '契約件数');
    }
    for (let colIndex = 5; colIndex <= 8; colIndex++) {
      panel.setCellData(0, colIndex, 'リピート');
    }
    for (let colIndex = 9; colIndex <= 12; colIndex++) {
      panel.setCellData(0, colIndex, '新規');
    }

    // 垂直方向にマージ
    ['MONTH'].forEach(function (binding) {
      let col = grid.getColumn(binding);
      col.allowMerging = true;
      panel.setCellData(0, col.index, col.header);
    });
    // ヘッダーの中央揃え
    grid.formatItem.addHandler((sender, e) => {
      // ヘッダーセルのスタイル設定
      if (e.panel === sender.columnHeaders) {
        e.cell.style.textAlign = 'center';
        e.cell.style.display = 'flex';
        e.cell.style.justifyContent = 'center';
        e.cell.style.alignItems = 'center';
      }

      // フッターセルのスタイル設定
      if (e.panel === sender.columnFooters) {
        const colIndex = e.col;
        const rowIndex = e.row;

        // フッターの1行目の線を太くする
        if (rowIndex === 0) {
          e.cell.style.borderTop = 'double';
        }

        if (rowIndex == 0 && [1, 5, 9].includes(colIndex)) {
          // 工事件数
          e.cell.style.backgroundColor = '#d9e1f2';
        } else if (rowIndex == 0 && [3, 7, 11].includes(colIndex)) {
          // 小工事件数
          e.cell.style.backgroundColor = '#ffff99';
        } else {
          // 他のセルの背景色をデフォルトに戻す
          e.cell.style.backgroundColor = '';
        }
      }
    });

    // フッターに１段追加
    grid.columnFooters.rows.push(new wjGrid.Row());

    // データ変更時に合計更新
    grid.collectionView.collectionChanged.addHandler(updateFooter);

    updateFooter(grid);
  }

  // 合計値を計算してフッターに設定
  function updateFooter(grid) {
    let data = grid?.itemsSource?.items;
    if (!data || data.length === 0) return;

    let panel = grid.columnFooters;

    grid.columns.forEach((col, colIndex) => {
      const binding = col.binding;
      if (binding === 'MONTH') {
        // 月
        panel.setCellData(0, colIndex, '合計');
      } else if (col.binding.endsWith('KEI_RATE')) {
        // 契約率
        const bindingSplits = binding.split('_');
        const currentOrBefore = bindingSplits[0];
        const target = bindingSplits[1];

        // 契約数
        const kei_count = data.reduce(
          (sum, item) => sum + (item[`KEI_${currentOrBefore}_${target}`] || 0),
          0
        );
        // 相談件数
        const soudan_count = data.reduce(
          (sum, item) => sum + (item[`${currentOrBefore}_${target}`] || 0),
          0
        );
        const keiRate = calcRate(kei_count, soudan_count, 4);
        panel.setCellData(0, colIndex, keiRate);
      } else if (col.binding.includes('BIG')) {
        // 前期
        let total = data.reduce((sum, item) => sum + (item[binding] || 0), 0);
        panel.setCellData(0, colIndex, total);

        // 今期
      } else {
        let total = data.reduce((sum, item) => sum + (item[binding] || 0), 0);
        panel.setCellData(0, colIndex, total);
      }
    });
  }

  return (
    <Container fluid className="p-0">
      <Row className="mt-2">
        <Col className="pl-3" md="7">
          <FlexGrid
            ref={gridRef}
            isReadOnly={true}
            allowMerging="ColumnHeaders"
            allowSorting={false}
            allowDragging={false}
            itemsSource={keiyakuLit}
            headersVisibility={'Column'}
            alternatingRowStep={0}
            initialized={onInitialized}
          >
            <FlexGridColumn
              binding="MONTH"
              header="月"
              allowMerging={true}
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_BIG_TOTAL"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="BIG_TOTAL_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_SMALL_TOTAL"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="SMALL_TOTAL_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_BIG_REPEAT"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="BIG_REPEAT_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_SMALL_REPEAT"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="SMALL_REPEAT_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_BIG_NEW"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="BIG_NEW_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KEI_SMALL_NEW"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={'*'}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="SMALL_NEW_KEI_RATE"
              header={`契％`}
              format="p1"
              width={'*'}
              align="center"
            ></FlexGridColumn>
          </FlexGrid>
        </Col>
        <Col className="pl-3" md="5">
          <wjChart.FlexChart
            header="移動年計　ご契約件数"
            itemsSource={quoteList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`工事`} binding="KEI_BIG_TOTAL" />
            <wjChart.FlexChartSeries name={`管・小`} binding="KEI_SMALL_TOTAL" />
          </wjChart.FlexChart>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="pl-3" md="6">
          <wjChart.FlexChart
            header={`工事　リピート・新規（契約件数）【累計】`}
            itemsSource={quoteList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`リピート`} binding="KEI_BIG_REPEAT" />
            <wjChart.FlexChartSeries name={`新規`} binding="KEI_BIG_NEW" />
          </wjChart.FlexChart>
        </Col>
        <Col className="pl-3" md="6">
          <wjChart.FlexChart
            header={`管・小　リピート・新規（契約件数）【累計】`}
            itemsSource={quoteList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`リピート`} binding="KEI_SMALL_REPEAT" />
            <wjChart.FlexChartSeries name={`新規`} binding="KEI_SMALL_NEW" />
          </wjChart.FlexChart>
        </Col>
      </Row>
      <Row className="mt-2">
        {/* 前期のリピート・新規件数の円グラフ */}
        <Col className="pl-3" md="6">
          <wjChart.FlexPie
            header={`工事　リピート・新規（契約件数）【累計】`}
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
            itemsSource={[
              {
                category: 'リピート',
                value: bigRepeatCount,
                rate: bigRepeatCount / (bigRepeatCount + bigNewCount),
              },
              {
                category: '新規',
                value: bigNewCount,
                rate: bigNewCount / (bigRepeatCount + bigNewCount),
              },
            ]}
            bindingName="category"
            binding="value"
            startAngle={90}
          >
            <wjChart.FlexPieDataLabel content="{name}({rate:p0})" position="Center" />
          </wjChart.FlexPie>
        </Col>
        {/* 今期のリピート・新規件数の円グラフ */}
        <Col className="pl-3" md="6">
          <wjChart.FlexPie
            header={`管・小　リピート・新規（契約件数）【累計】`}
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
            itemsSource={[
              {
                category: 'リピート',
                value: smallRepeatCount,
                rate: smallRepeatCount / (smallRepeatCount + smallNewCount),
              },
              {
                category: '新規',
                value: smallNewCount,
                rate: smallNewCount / (smallRepeatCount + smallNewCount),
              },
            ]}
            bindingName="category"
            binding="value"
            startAngle={90}
          >
            <wjChart.FlexPieDataLabel content="{name}({rate:p0})" position="Center" />
          </wjChart.FlexPie>
        </Col>
      </Row>
    </Container>
  );
}
export default AnalysisKeiBigSmall;
